/*
    set equal height 
*/

export const setEqualHeight = (topDiv, botDivQuery) => {
  if (topDiv) {
    const botArea = topDiv.querySelectorAll(botDivQuery);
    if (botArea) {
      botArea.forEach((el) => { el.style.height = ''; });
      // Get height list
      const heights = Array.prototype.slice.call(botArea).map(function (botArea) {
        return [botArea, botArea.offsetHeight];
      });
      // Get higest height from botArea
      const maxHeight = Math.max.apply(null, heights.map(function (botArea) {
        return botArea[1];
      }));
      botArea.forEach((el) => { el.style.height = maxHeight + 'px'; });
    }
  }
};
